import { translateText } from 'utils';
import { calculateTime, getAssociatedStopEvent } from 'utils/dateAndTimeUtils';

const actionsHolder = {
    closeDropdown(e) {
        if (actionsHolder.containerRef && !actionsHolder.containerRef.current?.contains(e.target)) {
            actionsHolder.internalStateSetter({ isActionDropdownOpen: false, });
            document.removeEventListener("mousedown", actionsHolder.closeDropdown)
        }
    }
};


export default {
    refreshOn: ({ startTimerWatch, events }) => [startTimerWatch, events],
    init: async ({ events, prevTimerID }, _, internalStateSetter) => {
        // stop execution if there is no start_timer event
        const index = events.findLastIndex(e => e.event_name === "start_timer")
        if (index < 0) return;

        let timerID = prevTimerID;
        clearInterval(timerID)

        // check if the latest start_time event has no corresponding stop_event
        const event = getAssociatedStopEvent({ index, events })
        if (!event) {
            const from = events[index]?.from;
            timerID = setInterval(async () => {
                await internalStateSetter({ startTimerWatch: calculateTime(from) ?? "" })
            }, 5 * 1000)
        }
        internalStateSetter({ prevTimerID: timerID })

        return () => clearInterval(timerID)
    },
    'OrderEvent.ButtonWrapper.Button': ({ isOpen, timerContainerRef }, _, internalStateSetter) => {
        internalStateSetter({ isOpen: !isOpen })
    },
    'OrderEvent.Image': ({ url }, outlet) => {
        outlet({ action: 'view_media', url });
    },
    'OrderEvent.TranslateButton': async ({ translated, order_event, translation }, _, internalStateSetter) => {
        if (!translation) {
            const translatedText = await translateText(order_event.description)
            internalStateSetter({ translated: !translated, translation: translatedText })
        } else {
            internalStateSetter({ translated: !translated })
        }
    },
    'OrderEvent.TimerContainer': ({ action, payload }, outlet, internalStateSetter) => {
        if (!action) return

        if (action === "close") {
            internalStateSetter({ isEditMode: false, isOpen: false })
            return
        }

        outlet({ action, payload });
        internalStateSetter({ isEditMode: false, isOpen: false })
    },
    'OrderEvent.AddAndStopTimerWrapper.ActionDropdownButton': ({
        dropdownRef,
        isActionDropdownOpen
    }, outlet, internalStateSetter) => {
        actionsHolder.internalStateSetter = internalStateSetter
        actionsHolder.containerRef = dropdownRef
        internalStateSetter({ isActionDropdownOpen: !isActionDropdownOpen, })

        if (isActionDropdownOpen) {
            document.removeEventListener("mousedown", actionsHolder.closeDropdown);
        } else {
            document.addEventListener("mousedown", actionsHolder.closeDropdown);
        }
    },
    'OrderEvent.AddAndStopTimerWrapper.OuterWrapper.Body.Wrapper.Edit': ({
        isEditMode,
        timerContainerRef
    }, outlet, internalStateSetter) => {
        if (timerContainerRef?.current) {
            setTimeout(() => timerContainerRef.current.scrollIntoView({
                behavior: "smooth",
                block: "end",
                inline: "nearest"
            }), 250)
        }
        internalStateSetter({ isEditMode: !isEditMode, })
    },
};
